/**
 * @deprecated Import from `./slotDates` instead.
 * Kept so native callers of `mockSlots` keep resolving without behavior change.
 */
export {
  DEFAULT_SLOT_DATE_COUNT,
  buildSlotDates,
  formatLongDate,
  formatShortDate,
  toIsoDate,
} from './slotDates';
